import { styled } from '@mui/material/styles';

import { APP_ENV } from '../../app/environment';
import { THEME } from '../../theming/theme';
import colors from '../../theming/tokens/colors';

const marginTopBottom = {
  [THEME.DA_DIREKT_THEME]: '1.5rem',
  [THEME.DA_KAUFLAND_THEME]: '1.5rem',
  DEFAULT: '2.5rem',
};

const marginLeftRight = {
  [THEME.DENTOLO_LEFT_ALIGN_THEME]: '1rem',
  DEFAULT: 0,
};

const getMarginBottom = (theme) => {
  const marginBottom = marginTopBottom[theme?.name] || marginTopBottom.DEFAULT;

  return APP_ENV === 'beta' ? '5rem' : marginBottom;
};

export const StyledSchemaContainer = styled('div')(({ theme }) => ({
  'margin-top': marginTopBottom[theme?.name] || marginTopBottom.DEFAULT,
  'margin-right': marginLeftRight,
  'margin-bottom': getMarginBottom(theme),
  'margin-left': marginLeftRight,
  'font=family': theme?.typography?.fontFamily,
  'font-size': '16px',
  '-webkit-font-smoothing': 'antialiased',
  '-moz-osx-font-smoothing': 'grayscale',
}));

export const StyledSchemaLoaderContainer = styled('div')`
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-40%, -50%);
  margin: 0 auto;
  width: 16rem;
  height: auto;
  text-align: center;
`;

export const StyledBranchName = styled('div')`
  position: fixed;
  width: 100%;
  bottom: 0;
  right: 0;
  padding: 0.5rem;
  ${({ theme }) => theme?.typography?.body};
  color: ${colors.PRODUCT_BLUE};
  background: ${colors.WHITE};
  text-align: right;
`;
